import { useState } from "react";
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
} from "@material-tailwind/react";

const sentimentColorMap = {
    positive: { bg: "bg-green-200", text: "text-green-900" },
    neutral: { bg: "bg-yellow-200", text: "text-yellow-900" },
    negative: { bg: "bg-red-200", text: "text-red-900" },
    void: { bg: "bg-gray-200", text: "text-gray-900" },
};

export default function SentimentBar({ sentiment, themeCount }) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen((open) => !open);
    };

    if (!sentiment) {
        const { bg, text } = sentimentColorMap.void;
        return (
            <span
                className={`${bg} ${text} rounded px-2 py-0.5 text-sm font-medium`}
            >
                N/A
            </span>
        );
    }

    const { bg, text } =
        sentimentColorMap[sentiment.overall] || sentimentColorMap.void;

    const renderRow = (label, value, type) => {
        const color = sentimentColorMap[type];
        return (
            <div className="flex-col">
                <div className="p-2 font-medium">{label}</div>
                <div className="p-2">
                    {color ? (
                        <span
                            className={`${color.bg} ${color.text} rounded px-1 mx-0.5`}
                        >
                            {value}
                        </span>
                    ) : (
                        <span className="text-black">{value}</span>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            {/* Sentiment bar as a highlight tag */}
            <span
                className={`${bg} ${text} rounded px-2 py-0.5 text-sm font-medium cursor-pointer`}
                onClick={() => setOpen(true)}
            >
                {sentiment.overall}
            </span>

            {/* Dialog */}
            <Dialog
                open={open}
                handler={handleClose}
                className="dialog"
            >
                <DialogBody className="text-black">
                    {!(themeCount > 0) && (
                        <Typography className=" text-center">
                            Response has not been allocated to any theme yet
                        </Typography>
                    )}
                    <div className="flex flex-row justify-center">
                        {renderRow(
                            "Positive",
                            Math.trunc(sentiment.positive * 100),
                            "positive",
                        )}
                        {renderRow(
                            "Neutral",
                            Math.trunc(sentiment.neutral * 100),
                            "neutral",
                        )}
                        {renderRow(
                            "Negative",
                            Math.trunc(sentiment.negative * 100),
                            "negative",
                        )}
                        {renderRow("Mixed", Math.trunc(sentiment.mixed * 100))}
                    </div>
                </DialogBody>
            </Dialog>
        </>
    );
}
